var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('location-topic-resoposible-table', {
    attrs: {
      "type": "responsible",
      "table-datas": _vm.responsibles,
      "color-picker": true
    },
    on: {
      "onAdd": _vm.onAdd,
      "onRemove": _vm.onRemove,
      "onSaveEdit": _vm.onSaveEdit
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('img', {
          attrs: {
            "src": require("@/assets/master-data/people.svg")
          }
        })];
      },
      proxy: true
    }, {
      key: "title",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.$t('responsible.title')) + " ")];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }